"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endOf = exports.add = void 0;
exports.formatCountdownTime = formatCountdownTime;
exports.formatDateTime = formatDateTime;
exports.formatInterval = formatInterval;
exports.formatSimple = formatSimple;
exports.getCapitalCity = getCapitalCity;
exports.getDSTTimeStamp = getDSTTimeStamp;
exports.getDiffByTimestamp = getDiffByTimestamp;
exports.getDiffTime = getDiffTime;
exports.getFormatTimeByBrowserTimezone = getFormatTimeByBrowserTimezone;
exports.getFormatTimeByPattern = getFormatTimeByPattern;
exports.getMonthStartEnd = getMonthStartEnd;
exports.getOffset = getOffset;
exports.getTimeStamp = getTimeStamp;
exports.getTimezoneByCityId = getTimezoneByCityId;
exports.getUTCTimeStamp = getUTCTimeStamp;
exports.getWeekStartEnd = getWeekStartEnd;
exports.getYearStartEnd = getYearStartEnd;
exports.getZeroTimeStamp = getZeroTimeStamp;
exports.subtract = exports.startOf = void 0;

var _base = require("./base");

// amPmMarkers 上下午标记
function date2str(locale, timeStamp, pattern, amPmMarkers) {
  if (!amPmMarkers) pattern = pattern.replace(/h/g, 'H');
  var time = timeStamp;

  if (!(timeStamp instanceof Date)) {
    time = new Date(timeStamp * 1000);
  }

  var hour = time.getHours();
  var patternMap = {
    M: time.getMonth() + 1,
    MMM: time.toLocaleString(locale, {
      month: 'short'
    }),
    E: time.toLocaleString(locale, {
      weekday: 'short'
    }),
    d: time.getDate(),
    H: hour,
    h: hour === 0 ? 12 : hour > 12 ? hour - 12 : hour,
    m: time.getMinutes(),
    s: time.getSeconds(),
    y: time.getFullYear(),
    S: time.getMilliseconds()
  };
  return pattern.replace(/(E+|M+|d+|H+|h+|m+|s+|S+|y+|a|'[a-z]+')/g, function (v) {
    if (/'[a-z]+'/.test(v)) return v.replace(/'/g, '');
    if (/a/.test(v)) return amPmMarkers instanceof Array ? amPmMarkers[~~(patternMap.H > 11)] : amPmMarkers;
    var key = v.slice(-1);
    if (v === 'MMM') key = 'MMM';
    var patternToString = patternMap[key].toString().slice(-(v.length > 2 ? patternMap[key].length : 2));

    while (patternToString.length < v.length && /^\d+$/.test(patternToString)) {
      patternToString = "0" + patternToString;
    }

    return patternToString;
  });
}

function formatDateTime(timeStamp, dateStyle, timeStyle, showOffset) {
  var offsetTime = (0, _base.getOffsetTime)(parseInt(timeStamp, 10));
  var offset = getOffset((0, _base.getTimezone)(), timeStamp) / 3600;

  var _getBaseInfo = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo.locale;

  var _getFormat = (0, _base.getFormat)(offsetTime, dateStyle, timeStyle),
      dateFormat = _getFormat.dateFormat,
      timeFormat = _getFormat.timeFormat,
      format = _getFormat.format,
      amPmMarkers = _getFormat.amPmMarkers;

  var utcStr = offset >= 0 ? "UTC+".concat(offset) : "UTC".concat(offset);
  if (!timeFormat && !dateFormat) return null;
  if (!timeFormat) return showOffset ? "".concat(date2str(locale, offsetTime, dateFormat, amPmMarkers), " ").concat(utcStr) : date2str(locale, offsetTime, dateFormat, amPmMarkers);
  if (!dateFormat) return showOffset ? "".concat(date2str(locale, offsetTime, timeFormat, amPmMarkers), " ").concat(utcStr) : date2str(locale, offsetTime, timeFormat, amPmMarkers);
  return format.replace("{1}", date2str(locale, offsetTime, dateFormat, amPmMarkers)).replace("{0}", showOffset ? "".concat(date2str(locale, offsetTime, timeFormat, amPmMarkers), " ").concat(utcStr) : date2str(locale, offsetTime, timeFormat, amPmMarkers));
} // 倒计时 


function formatCountdownTime(seconds, isHighlight) {
  if (seconds < 0) throw Error("Elvish Error: negative is not valid");
  var duration = (0, _base.getDuration)(seconds);
  var d = Math.floor(seconds / 3600 / 24);
  var h = Math.floor(seconds % (3600 * 24) / 3600);
  var m = Math.floor(seconds % 3600 / 60);
  var s = seconds % 60;

  if (d) {
    return h || duration.indexOf('{1}') > -1 ? duration.replace(/\{1\}/, isHighlight ? "{".concat(d, "}") : d).replace(/\{0\}/, isHighlight ? "{".concat(h, "}") : h) : duration.replace(/\{0\}/, isHighlight ? "{".concat(d, "}") : d);
  }

  if (h) {
    return m || duration.indexOf('{1}') > -1 ? duration.replace(/\{1\}/, isHighlight ? "{".concat(h, "}") : h).replace(/\{0\}/, isHighlight ? "{".concat(m, "}") : m) : duration.replace(/\{0\}/, isHighlight ? "{".concat(h, "}") : h);
  }

  if (m) {
    return s || duration.indexOf('{1}') > -1 ? duration.replace(/\{1\}/, isHighlight ? "{".concat(m, "}") : m).replace(/\{0\}/, isHighlight ? "{".concat(s, "}") : s) : duration.replace(/\{0\}/, isHighlight ? "{".concat(m, "}") : m);
  }

  return duration.replace(/\{0\}/, isHighlight ? "{".concat(s, "}") : s);
}

function getCapitalCity(country) {
  var countryInfo = (0, _base.getCountryTimezone)(country);

  try {
    return countryInfo.timezones.filter(function (timezone) {
      return timezone.capital;
    })[0];
  } catch (e) {
    return null;
  }
}

function getOffset(timezone, timeStamp) {
  return (0, _base.getOffsetBase)(timezone, parseInt(timeStamp, 10));
} // 时间区间的格式化


function formatInterval(startTime, endTime, dateStyle, timeStyle) {
  startTime = parseInt(startTime, 10);
  endTime = parseInt(endTime, 10);
  var stypeMap = ["DATE_DD_MM_YYYY", "DATE_DD_MTH", "TIME_HH_MM", "DATE_NONE", "TIME_NONE"];

  if (startTime < 0 || startTime > endTime) {
    throw Error("Elvish Error: invalid time parameters");
  }

  if (!~stypeMap.indexOf(dateStyle)) throw Error("Elvish Error: invalid dateStyle parameters");
  if (!~stypeMap.indexOf(timeStyle)) throw Error("Elvish Error: invalid timeStyle parameters");
  var startOffsetTime = (0, _base.getOffsetTime)(startTime);
  var endOffsetTime = (0, _base.getOffsetTime)(endTime);

  var _getBaseInfo2 = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo2.locale;

  var pattern = (0, _base.getIntervalPattern)(startOffsetTime, endOffsetTime, dateStyle, timeStyle);
  var spliter = pattern.match(/\s\W\s/)[0];
  var patternArr = pattern.split(spliter);
  return patternArr.length === 2 ? date2str(locale, startOffsetTime, pattern.split(spliter)[0], (0, _base.getFormat)(startOffsetTime, dateStyle, timeStyle).amPmMarkers) + spliter + date2str(locale, endOffsetTime, pattern.split(spliter)[1], (0, _base.getFormat)(endOffsetTime, dateStyle, timeStyle).amPmMarkers) : date2str(locale, startOffsetTime, pattern.split(spliter)[0], (0, _base.getFormat)(startOffsetTime, dateStyle, timeStyle).amPmMarkers);
} // 简单时间的格式化


function formatSimple(timeStamp, style) {
  var styleMap = {
    "STYLE_YMDHMS": "yyyy-MM-dd HH:mm:ss",
    "STYLE_YMD": "yyyy-MM-dd"
  };

  var _getBaseInfo3 = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo3.locale;

  var offsetTime = (0, _base.getOffsetTime)(parseInt(timeStamp, 10));

  var _getFormat2 = (0, _base.getFormat)(offsetTime),
      amPmMarkers = _getFormat2.amPmMarkers;

  return date2str(locale, offsetTime, styleMap[style], amPmMarkers);
}

function getWeekStartEnd(timeStamp, style) {
  var current = new Date(timeStamp * 1000);
  current.setHours(0, 0, 0, 0);
  console.log('current=>', current); // getDay函数:Sunday-Saturday:0-6

  var weekstart; // 当时间戳为星期日时，减去7天

  if (current.getDay() === 0) {
    weekstart = current.getDate() - 7 + 1;
  } else {
    weekstart = current.getDate() - current.getDay() + 1;
  }

  var weekend = weekstart + 6;
  var monday = new Date(new Date(current).setDate(weekstart));
  var sunday = new Date(new Date(current).setDate(weekend));
  console.log('monday=>', monday);
  sunday.setHours(23, 59, 59, 0);

  if (style === 'TIMESTAMP') {
    return [+monday / 1000 * 2 - (0, _base.getOffsetTime)(+monday / 1000), +sunday / 1000 * 2 - (0, _base.getOffsetTime)(+sunday / 1000)];
  }

  return [date2str("en-US", +new Date(monday) / 1000, "yyyy-MM-dd HH:mm:ss"), date2str("en-US", +new Date(sunday) / 1000, "yyyy-MM-dd HH:mm:ss")];
}

function getMonthStartEnd(timeStamp) {
  var current = new Date(timeStamp * 1000);
  current.setDate(1);
  current.setHours(0, 0, 0, 0);
  var start = +new Date(current);
  current.setMonth(current.getMonth() + 1);
  current.setDate(0);
  current.setHours(23, 59, 59, 0);
  var end = +new Date(current);
  return [start / 1000 * 2 - (0, _base.getOffsetTime)(start / 1000), end / 1000 * 2 - (0, _base.getOffsetTime)(end / 1000)];
}

function getYearStartEnd(timeStamp) {
  var current = new Date(timeStamp * 1000);
  current.setDate(1);
  current.setMonth(0);
  current.setHours(0, 0, 0, 0);
  var start = +new Date(current);
  current.setMonth(12);
  current.setDate(0);
  current.setHours(23, 59, 59, 0);
  var end = +new Date(current);
  return [start / 1000 * 2 - (0, _base.getOffsetTime)(start / 1000), end / 1000 * 2 - (0, _base.getOffsetTime)(end / 1000)];
} // 时间字符串=>获取时间戳, 可能有问题


function getTimeStamp(time) {
  // let fakeTimeStamp = +new Date(time);
  // node低版本不支持repaceAll函数
  var timeStr = time.replace(/\-/g, '/');
  var fakeTimeStamp = Date.parse(new Date(timeStr));
  return fakeTimeStamp / 1000 * 2 - (0, _base.getOffsetTime)(fakeTimeStamp / 1000);
}

function matchTime(pattern, time) {
  return function (reg) {
    var matched = pattern.match(new RegExp(reg));
    return matched ? time.substr(matched.index, matched[0].length) - (reg === "M+" ? 1 : 0) : 0;
  };
} // 时间字符串=>获取utc时间戳（偏移过的时间戳，但未将时令时间差计算进来）


function getUTCTimeStamp(time, pattern) {
  var matchFn = matchTime(pattern, time); //Date.UTC返回从 1970 年 1 月 1 日 00:00:00 UTC 到指定时间的毫秒数

  var UTC = Date.UTC(matchFn("y+"), matchFn("M+"), matchFn("d+"), matchFn("H+"), matchFn("m+"), matchFn("s+")) / 1000;
  return UTC - (0, _base.getOffsetBase)((0, _base.getTimezone)(), UTC);
} // 时间字符串=>获取utc时间戳（偏移过的时间戳，将时令时间差计算进来）


function getDSTTimeStamp(time, pattern) {
  var matchFn = matchTime(pattern, time); //Date.UTC返回从 1970 年 1 月 1 日 00:00:00 UTC 到指定时间的毫秒数

  var UTC = Date.UTC(matchFn("y+"), matchFn("M+"), matchFn("d+"), matchFn("H+"), matchFn("m+"), matchFn("s+")) / 1000;
  return UTC - (0, _base.getOffsetBase)((0, _base.getTimezone)(), UTC - (0, _base.getOffsetBase)((0, _base.getTimezone)(), UTC));
}

function getFormatTimeByPattern(time, pattern) {
  var _getBaseInfo4 = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo4.locale;

  var offsetTime = (0, _base.getOffsetTime)(parseInt(time, 10));

  var _getFormat3 = (0, _base.getFormat)(offsetTime),
      amPmMarkers = _getFormat3.amPmMarkers;

  return date2str(locale, offsetTime, pattern, amPmMarkers);
}

function getTimezoneByCityId(cityId) {
  return (0, _base.getTimezone)(cityId);
} //该天的0点时间戳


function getZeroTimeStamp(timeStamp) {
  return getTimeStamp(new Date(timeStamp * 1000).setHours(0, 0, 0, 0));
}

function getFormatTimeByBrowserTimezone(timeStamp, pattern) {
  var _getBaseInfo5 = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo5.locale;

  var _getFormat4 = (0, _base.getFormat)(timeStamp),
      amPmMarkers = _getFormat4.amPmMarkers;

  return date2str(locale, timeStamp, pattern, amPmMarkers);
}

var getAddSubtractString = function getAddSubtractString(timeStamp, number, unit) {
  var formatDate = getFormatTimeByPattern(timeStamp, "yyyy/MM/dd HH:mm:ss");
  var date = new Date(formatDate);

  switch (unit) {
    case 'week':
      date.setDate(date.getDate() + 7 * number);
      break;

    case 'month':
      date.setMonth(date.getMonth() + number);
      break;

    case 'year':
      date.setYear(date.getFullYear() + number);
      break;

    default:
      date.setDate(date.getDate() + number);
  }

  var _getBaseInfo6 = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo6.locale;

  var dateString = date2str(locale, date, "yyyy/MM/dd HH:mm:ss");
  return getTimeStamp(dateString);
};
/** @function add
 * @param {number} timeStamp
 * @param {number} number
 * @param {('s'|'m'|'h'|'d'|'w'|'m'|'y'|'second'|'minute'|'hour'|'day'|'week'|'month'|'year')} units
 * @returns {number} timestamp
 */


var add = function add(timeStamp, number, units) {
  number = Number(number);
  var unit = (0, _base.prettyUnit)(units);
  var minuteDuration = 60;
  var hourDuration = minuteDuration * 60;

  switch (unit) {
    case 'second':
      return timeStamp + number;

    case 'minute':
      return timeStamp + number * minuteDuration;

    case 'hour':
      return timeStamp + number * hourDuration;

    default:
      return getAddSubtractString(timeStamp, number, unit);
  }
};

exports.add = add;

var subtract = function subtract(timeStamp, number, units) {
  number = Number(number);
  return add(timeStamp, -1 * number, units);
};

exports.subtract = subtract;

var startOf = function startOf(timeStamp, units) {
  var startOf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isStartOf = typeof startOf !== 'undefined' ? startOf : true;
  var formatDate = getFormatTimeByPattern(timeStamp, "yyyy/MM/dd HH:mm:ss");
  var unit = (0, _base.prettyUnit)(units);
  var date = new Date(formatDate);

  switch (unit) {
    case 'week':
      date.setDate(isStartOf ? date.getDate() - date.getDay() : date.getDate() + (6 - date.getDay()));
      break;

    case 'month':
      !isStartOf && date.setMonth(date.getMonth() + 1);
      date.setDate(isStartOf ? 1 : 0);
      break;

    case 'year':
      date.setMonth(isStartOf ? 0 : 11);
      date.setDate(isStartOf ? 1 : 31);
      break;
  }

  date.setHours(isStartOf ? 0 : 23);
  date.setMinutes(isStartOf ? 0 : 59);
  date.setSeconds(isStartOf ? 0 : 59);

  var _getBaseInfo7 = (0, _base.getBaseInfo)(),
      locale = _getBaseInfo7.locale;

  var dateString = date2str(locale, date, "yyyy/MM/dd HH:mm:ss");
  return getTimeStamp(dateString);
};

exports.startOf = startOf;

var endOf = function endOf(timeStamp, units) {
  return startOf(timeStamp, units, false);
}; // 得到两个时间字符串之间的差值
// unit枚举值：day, hour, minute, second


exports.endOf = endOf;

function getDiffTime(dateStart, dateEnd, pattern, unit) {
  // const stamp1 = new Date(dateStart).getTime() / 1000;
  // const stamp2 = new Date(dateEnd).getTime() / 1000;
  // const offset1 = getOffsetBase(getTimezone(), getUTCTimeStamp(dateStart, pattern));
  // const offset2 = getOffsetBase(getTimezone(), getUTCTimeStamp(dateEnd, pattern));
  // const diffSecond = (stamp2 - offset2) - (stamp1 - offset1);
  if (!dateStart || !dateEnd) {
    throw Error("Elvish Error: invalid date parameters");
  }

  if (!pattern) {
    throw Error("Elvish Error: invalid pattern parameters");
  }

  var stamp1 = getDSTTimeStamp(dateStart, pattern);
  var stamp2 = getDSTTimeStamp(dateEnd, pattern);
  var diffSecond = stamp2 - stamp1;

  if (diffSecond < 0) {
    throw Error("Elvish Error: invalid time parameters");
  }

  var result = (0, _base.getDiff)(diffSecond, unit);
  return result;
} // 得到两个时间戳之间的差值
// unit枚举值：day, hour, minute, second


function getDiffByTimestamp(stampStart, stampEnd, unit) {
  if (!stampStart || !stampEnd || stampStart > stampEnd) {
    throw Error("Elvish Error: invalid time parameters");
  }

  var diffSecond = stampEnd - stampStart;
  var result = (0, _base.getDiff)(diffSecond, unit);
  return result;
}